import { render, staticRenderFns } from "./joinusdy.vue?vue&type=template&id=37abfc2a&scoped=true"
import script from "./joinusdy.vue?vue&type=script&lang=js"
export * from "./joinusdy.vue?vue&type=script&lang=js"
import style0 from "./joinusdy.vue?vue&type=style&index=0&id=37abfc2a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0__lodash_sniwsisxdvcgzet3yrvlfqnueq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37abfc2a",
  null
  
)

export default component.exports